var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer mt-auto py-3 bg-dark"},[_c('div',{staticClass:"container text-center text-light"},[_c('span',[_vm._v("© 2024 里世界玩家终端. QQ:314733645")])])])
}]

export { render, staticRenderFns }